import { render, staticRenderFns } from "./commod.vue?vue&type=template&id=3ca5fb0e&scoped=true&"
import script from "./commod.vue?vue&type=script&lang=js&"
export * from "./commod.vue?vue&type=script&lang=js&"
import style0 from "./commod.vue?vue&type=style&index=0&id=3ca5fb0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca5fb0e",
  null
  
)

export default component.exports